/** Backend identifier for walk-in customer (do not translate for API payloads). */
export const WALK_IN_CUSTOMER_ID = 'Walk in Customer';
